import axios from 'axios';
import { getCredentials, getConfig } from './woo';

const getWpApiBase = () => {
  const credentials = getCredentials();
  const wpApiUrl = getConfig(credentials, 'WP_API_URL');
  if (!wpApiUrl) throw new Error('WP_API_URL no está configurado');
  return `${wpApiUrl}/datofy/v1`;
};

export const getAdminUsers = async (filters = {}) => {
  const base = getWpApiBase();
  const response = await axios.get(`${base}/admin/users`, { params: filters });
  return response.data;
};

export const getAdminUser = async (id) => {
  const base = getWpApiBase();
  const response = await axios.get(`${base}/admin/user/${id}`);
  return response.data;
};

export const createAdminUser = async (userData) => {
  const base = getWpApiBase();
  const response = await axios.post(`${base}/admin/users`, userData);
  return response.data;
};

export const updateAdminUser = async (id, userData) => {
  const base = getWpApiBase();
  const response = await axios.put(`${base}/admin/user/${id}`, userData);
  return response.data;
};

export const deleteAdminUser = async (id) => {
  const base = getWpApiBase();
  const response = await axios.delete(`${base}/admin/user/${id}`);
  return response.data;
};

export const setUserStatus = async (id, status) => {
  const base = getWpApiBase();
  const response = await axios.put(`${base}/admin/user/${id}/status`, { status });
  return response.data;
};
